import { h, Component } from 'preact';
import util, { getDesignDimensions, getDesignSizeLabel } from "../util";
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import Renderer from "../canvas/renderer";
import designService from "../service/designService";
import designDomain from "../domain/designDomain";
import $ from "jquery";
import MakeCopyModal from "./MakeCopyModal";
import { setLineHeights } from "../canvas/line-height";
import { hasLayoutGuidesSupport, hideLayoutGuides } from "../canvas/layout-guides";
import { fixDimensionsAfterResize, fixPositionForMenuResize, fixPositionForTableTentResize, fixPositionForTakeoutResize, fixPositionScaledResize } from "../canvas/dimension";
import { reselect } from "../canvas/selection";
import { fitToPage } from "../canvas/zoom";
import { rulerIsToggled, resetRulerAfterResize } from "../canvas/page-ruler";
import Interactable from "../canvas/interactable";
import canvas from "../canvas";
import constants from '../constants';

const MENUS = [
  { key: 'menu-letter', label: 'Letter', ops: [{ key: 'menu-letter', label: 'Portrait' }, { key: 'menu-letter-landscape', label: 'Landscape' }] },
  { key: 'menu-legal', label: 'Legal', ops: [{ key: 'menu-legal', label: 'Portrait' }, { key: 'menu-legal-landscape', label: 'Landscape' }] },
  { key: 'menu-tabloid', label: 'Tabloid', ops: [{ key: 'menu-tabloid', label: 'Portrait' }, { key: 'menu-tabloid-landscape', label: 'Landscape' }] },
  { key: 'menu-a4', label: 'A4', ops: [{ key: 'menu-a4', label: 'Portrait' }, { key: 'menu-a4-landscape', label: 'Landscape' }] }
];

@connect(reduce, actions)
class DropdownResize extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedSize: '',
      sizes: util.sizes,
      isMakeCopyModal: false,
      width: '',
      height: '',
      unit: 'in',
      error: '',
      searchBy: '',
    };

    this.onCustomChanged = this.onCustomChanged.bind(this);
    this.validateCustomSize = this.validateCustomSize.bind(this);
    this.onChangeCustomWidth = this.onChangeCustomWidth.bind(this);
    this.onChangeCustomHeight = this.onChangeCustomHeight.bind(this);
    this.onChangeCustomUnit = this.onChangeCustomUnit.bind(this);
    this.resize = this.resize.bind(this);

    this.showVariations = (ev) => {
      $('.variations').hide();
      $(ev.target).closest('li').find('.variations').show();
      ev.stopPropagation();
    };

    this.selectSize = (ev, size) => {
      this.setState({ selectedSize: size });
      this.setState({ width: '', height: '', unit: 'in' });

      $('.variations').hide();
      $('li').removeClass('selected');


      $(ev.target).parents('.variations').show();
      $(ev.target).closest('li').addClass('selected');

      if (props.embedded !== true) {
        ev.stopPropagation();
      } else {
        props.onSelectedSize(size);
      }
    };

    this.copyAndResize = () => {
      const selectedSize = this.state.selectedSize;

      if (!selectedSize) return;
      else if (selectedSize === 'custom' && (!this.state.width || !this.state.height || !this.state.unit || this.state.error)) return;

      /*if (this.props.onCopyResize) {
          this.props.onCopyResize(this.state.selectedSize, this.state.width, this.state.height, this.state.unit);
      } else {*/
      this.setState({ isMakeCopyModal: true });
      $('body').trigger('click');
      //}
    };

    this.getPromoTemplates = (size) => {
      this.props.setPublicPromoDesigns([], true);
      designService.getTemplatesByStatusAndSize('published', size.key).then(response => {
        const designs = response.data.map(design => new designDomain.Design(design, util.sizes));
        this.props.setPublicPromoDesigns(designs);
      }).catch(() => {
        this.props.setPublicPromoDesigns([], false);
      });
    };

    this.onMakeCopyModalClose = () => {
      this.setState({ isMakeCopyModal: false })
    }

    this.onChangeSearchField = (ev) => {
      this.setState({ searchBy: ev.target.value });

      let term = this.state.searchBy;

      if (term === '') {
        $('.option-item').each(function () { $(this).show(); });
        $('.size-label').each(function () { $(this).parent().show(); });
        $('.variations').hide();
        $('.no-size-results').hide();
      } else {
        function searchOptionDims(searchTermArray) {
          $('.option-item').each(function () {
            let optionDimArray = $(this).children('.option-dimensions').text().replace(/[^0-9.]/g, ' ').split(/\s/).filter(Boolean);
            // for each searched dimension
            let notIncludesAll = searchTermArray.some(function (searchTerm) {
              let dimIndex = 0;
              // see if option-item's existing dimensions start with searched dimension
              let containsTerm = optionDimArray.some(function (dim) {
                if (dim.startsWith(searchTerm)) { return true; }
                dimIndex++;
                return false;
              });
              // remove from option-item's dimension array
              if (!containsTerm) { return true; }
              delete optionDimArray[dimIndex];
              optionDimArray = optionDimArray.filter(Boolean);
              return false;
            });
            if (notIncludesAll) {
              $(this).hide()
            } else {
              $(this).show();
            }
          })
        }

        function searchOptionText(term) {
          const onlyVariations = term.includes('portrait') || term.includes('landscape');
          const keyTerm = term.replace(/portrait|landscape/g, '').trim();
          $('.option-item').each(function () {
            const thisJS = $(this);
            const termIncludes = thisJS.children('.option-label').text().toLowerCase().includes(keyTerm);
            if (onlyVariations) {
              if (termIncludes && thisJS.children('.variations').length > 0) {
                thisJS.show();
              } else {
                thisJS.hide();
              }
            } else {
              if (termIncludes) {
                thisJS.show();
              } else {
                thisJS.hide();
              }
            }
          })

          $('.size-label').each(function () {
            const $this = $(this);
            if ($this.text().toLowerCase().includes(term.toLowerCase())) {
              const options = $this.parent().find('.option-item');
              options.each(function () {
                $(this).show();
              })
            }
          });
        }

        term = term.toLowerCase();
        // if term starts with a number it's most likely a dimension
        if (term.match(/^\d/)) {
          let term_array = term.replace(/[^0-9.]/g, ' ').split(/\s/).filter(Boolean);
          searchOptionDims(term_array);
        } else { // otherwise search the label text
          searchOptionText(term);
        }

        // hide size labels that have no possible options
        $('.size-label').not('.custom-label').each(function () {
          let chilRemain = $(this).parent().find('.option-item').filter(function () {
            return $(this).css('display') != 'none';
          }).length > 0;
          if (chilRemain) {
            $(this).parent().show();
          } else {
            $(this).parent().hide();
          }
        });

        // if no results, suggest custom size
        let someRemain = $('.size-label').not('.custom-label').filter(function () {
          return $(this).parent().css('display') !== 'none';
        }).length > 0;
        if (someRemain) {
          $('.no-size-results').hide();
          $('.sep').show();
        } else {
          $('.no-size-results').show();
          $('.sep').hide();
        }
      }
    };
  }

  resize() {
    Interactable.storeTempRatios();

    const selectedSize = this.state.selectedSize;
    if (!selectedSize) return;
    else if (selectedSize === 'custom' && (!this.state.width || !this.state.height || !this.state.unit || this.state.error)) return;

    const oldSize = this.state.sizes.find(current => current.key === this.props.designSize);
    const size = this.state.sizes.find(current => current.key === selectedSize);

    if (selectedSize === 'custom') {
      size.width = this.state.width;
      size.height = this.state.height;
      size.unit = this.state.unit;

      if (size.unit === 'in') {
        size.width = parseFloat(this.state.width) + 0.25;
        size.height = parseFloat(this.state.height) + 0.25;
        size.bleed = 0.25;
      }
    }

    if (size.key === 'custom' && size.unit === 'in') {
      if (!$('.bleed-shadow-top').children().length) {
        $('.bleed-shadow-top').append('<div class="safe-zone-label">SAFE ZONE</div>');
      }
    } else if (size.key !== 'custom' && size.key !== 'fb-post' && size.key !== 'fb-story' && size.key !== 'insta-story' && size.key !== 'insta-post' && size.key !== 'logo' && size.key !== 'digital-menu-board' && size.key !== 'digital-menu-board-portrait') {
      if (!$('.bleed-shadow-top').children().length) {
        $('.bleed-shadow-top').append('<div class="safe-zone-label">SAFE ZONE</div>');
      }
    } else {
      $('.bleed-shadow-top').empty();
    }

    this.props.setDesignSize(size);

    Renderer.setPageSize(size);
    util.nextTick(() => {
      setLineHeights();
      fitToPage();
      util.nextTick(() => Interactable.resetAllPositions());
      fixDimensionsAfterResize();
      reselect();
      if (!hasLayoutGuidesSupport(size.key)) {
        hideLayoutGuides();
      }

      if (size.category === 'takeouts' ||
        size.key === 'folded-menu-letter-trifold' ||
        size.key === 'folded-menu-legal-trifold' ||
        size.key === 'folded-menu-tabloid-trifold') {
        fixPositionForTakeoutResize(size, oldSize);
      // } else if (size.category === 'table-tents') {
        // fixPositionForTableTentResize(size, oldSize);
      } else if (util.isSizeLandscape(oldSize) && util.isSizePortrait(size)) {
        fixPositionForMenuResize(size, oldSize);
      } else if ((util.isSizeLandscape(oldSize) && util.isSizeLandscape(size)) ||
        (util.isSizePortrait(oldSize) && util.isSizePortrait(size))) {
        fixPositionScaledResize(size, oldSize);
      }

      // if (oldSize.category === 'digital-menu-boards' && size.category === 'menus') {
      //   fixPositionForMenuResize(size, oldSize);
      // }

    });

    this.props.setIsSaved(false);
    this.props.setIsSaving(true);

    designService.updateDesign({
      id: this.props.designId,
      size: size.key,
      width: this.state.width,
      height: this.state.height,
      unit: this.state.unit
    }).then(() => {
      this.props.setIsSaved(true);
      this.props.setIsSaving(false);
    });

    this.props.setPromoLoading(true);
    this.getPromoTemplates(size);


    const useMO = canvas.getDefaultTextTab() === 'mo';
    if (useMO) {
      this.props.goToView('text-mo');
      this.props.goToSubview('add-new');
    } else {
      this.props.goToView('text-plain');
    }
    util.hideDropdown();

    $('.variations').hide();
    $('li').removeClass('selected');
    this.setState({ selectedSize: '', width: '', height: '', unit: 'in' });
    if (this.props.onResize) this.props.onResize();

    if (rulerIsToggled()) {
      setTimeout(() => {
        resetRulerAfterResize();
      }, 1000);
    }
  }

  validateCustomSize(state) {
    $('li').removeClass('selected');

    let error = '';
    if (state.unit && state.width && state.height) {
      if (state.unit === 'in') {
        if (state.width < 1 || state.width > 36 || state.height < 1 || state.height > 36) {
          error = 'Dimensions must be between 1in and 36in.'
        }
      } else if (state.unit === 'px') {
        if (state.width < 96 || state.width > 3456 || state.height < 96 || state.height > 3456) {
          error = 'Dimensions must be between 96px and 3456px.'
        }
      }
    }

    if (error) {
      $('.dropdown-resize .scroller').animate({ scrollTop: 9999 }, 'fast');
    }
    return error
  }

  onCustomChanged(key, ev) {
    ev.stopPropagation();
    if (!this.props.hasPdfPermission) {
      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
      return;
    }

    const message = this.validateCustomSize({ ...this.state, [key]: ev.target.value });
    this.setState(prev => ({
      [key]: ev.target.value,
      selectedSize: !message ? 'custom' : prev.selectedSize,
      error: message || ''
    }));
  }

  onChangeCustomWidth(ev) {
    this.onCustomChanged('width', ev);
  }

  onChangeCustomHeight(ev) {
    this.onCustomChanged('height', ev);
  }

  onChangeCustomUnit(ev) {
    this.onCustomChanged('unit', ev);
  }

  componentDidMount() {
    $('.variations').hide();
    $('li').removeClass('selected');
    this.setState({ selectedSize: '' });
  }

  render(props, state) {
    const { width, height, unit } = getDesignDimensions(props);
    const sizeLabel = getDesignSizeLabel(props);
    let currentSizeLabel = width ? `${sizeLabel} ${width} x ${height} ${unit}` : '';

    return (
      <div className="dropdown-menu dropdown-resize dropdown-sticky" data-close="no">
        <div className="current-size">
          <b>Current Size:</b> {currentSizeLabel}
          <input className="search-sizes" placeholder="Search resize options"
            onKeyUp={util.debounce(this.onChangeSearchField.bind(this), 300)}
            onChange={util.debounce(this.onChangeSearchField.bind(this), 300)}>
          </input>
        </div>

        <div className="scroller" style="top: 22px; bottom: 60px;">
          <ul style='margin: 72px 0px 45px 0;'>
            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-menus-icon`} /></svg>
                Menu
              </span>
              <ul>
                {
                  MENUS.map(it => <li className="option-item" onClick={this.showVariations}>
                    <span className="option-label">{it.label}</span>
                    <span className="option-dimensions">{util.getSize(it.key).dimensionsLabel}</span>

                    <ul className="variations">
                      <li onClick={(e) => this.selectSize(e, it.ops[0].key)}><span className="variation-label">{it.ops[0].label}</span></li>
                      <li onClick={(e) => this.selectSize(e, it.ops[1].key)}><span className="variation-label">{it.ops[1].label}</span></li>
                    </ul>
                  </li>)
                }
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-digital-menu-boards-icon`} /></svg>
                Digital Menu Board
              </span>

              <ul>
                <li className="option-item" onClick={(e) => this.selectSize(e, 'digital-menu-board')}>
                  <span className="option-label">Landscape</span>
                  <span className="option-dimensions">16:9 Ratio</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'digital-menu-board-portrait')}>
                  <span className="option-label">Portrait</span>
                  <span className="option-dimensions">9:16 Ratio</span>
                </li>

                {/* <li onClick={(e) => this.selectSize(e, 'digital-menu-board-portrait')}><span className="variation-label">Portrait</span></li>
                <li onClick={(e) => this.selectSize(e, 'digital-menu-board')}><span className="variation-label">Landscape</span></li> */}
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-takeouts-icon`} /></svg>
                Takeout
              </span>
              <ul>
                <li className="option-item" onClick={(e) => this.selectSize(e, 'takeout-letter-trifold')}>
                  <span className="option-label">Letter Trifold</span>
                  <span className="option-dimensions">{util.getSize('takeout-letter-trifold').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'takeout-letter-bifold')}>
                  <span className="option-label">Letter Bifold</span>
                  <span className="option-dimensions">{util.getSize('takeout-letter-bifold').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'takeout-legal-trifold')}>
                  <span className="option-label">Legal Trifold</span>
                  <span className="option-dimensions">{util.getSize('takeout-legal-trifold').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'takeout-legal-quadfold')}>
                  <span className="option-label">Legal Quadfold</span>
                  <span className="option-dimensions">{util.getSize('takeout-legal-quadfold').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'takeout-tabloid-trifold')}>
                  <span className="option-label">Tabloid Trifold</span>
                  <span className="option-dimensions">{util.getSize('takeout-tabloid-trifold').dimensionsLabel}</span>
                </li>
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-flyers-icon`} /></svg>
                Flyer
              </span>
              <ul>
                <li className="option-item" onClick={this.showVariations}>
                  <span className="option-label">Letter</span>
                  <span className="option-dimensions">{util.getSize('letter').dimensionsLabel}</span>

                  <ul className="variations">
                    <li onClick={(e) => this.selectSize(e, 'letter')}><span className="variation-label">Portrait</span></li>
                    <li onClick={(e) => this.selectSize(e, 'letter-landscape')}><span className="variation-label">Landscape</span></li>
                  </ul>
                </li>

                <li className="option-item" onClick={this.showVariations}>
                  <span className="option-label">Legal</span>
                  <span className="option-dimensions">{util.getSize('legal').dimensionsLabel}</span>

                  <ul className="variations">
                    <li onClick={(e) => this.selectSize(e, 'legal')}><span className="variation-label">Portrait</span></li>
                    <li onClick={(e) => this.selectSize(e, 'legal-landscape')}><span className="variation-label">Landscape</span></li>
                  </ul>
                </li>

                <li className="option-item" onClick={this.showVariations}>
                  <span className="option-label">Tabloid</span>
                  <span className="option-dimensions">{util.getSize('tabloid').dimensionsLabel}</span>

                  <ul className="variations">
                    <li onClick={(e) => this.selectSize(e, 'tabloid')}><span className="variation-label">Portrait</span></li>
                    <li onClick={(e) => this.selectSize(e, 'tabloid-landscape')}><span className="variation-label">Landscape</span></li>
                  </ul>
                </li>

                <li className="option-item" onClick={this.showVariations}>
                  <span className="option-label">A4</span>
                  <span className="option-dimensions">{util.getSize('a4').dimensionsLabel}</span>

                  <ul className="variations">
                    <li onClick={(e) => this.selectSize(e, 'a4')}><span className="variation-label">Portrait</span></li>
                    <li onClick={(e) => this.selectSize(e, 'a4-landscape')}><span className="variation-label">Landscape</span></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-social-medias-icon`} /></svg>
                Social Media
              </span>
              <ul>
                <li className="option-item" onClick={(e) => this.selectSize(e, 'fb-post')}>
                  <span className="option-label">Facebook Post</span>
                  <span className="option-dimensions">{util.getSize('fb-post').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'insta-post')}>
                  <span className="option-label">Instagram Post</span>
                  <span className="option-dimensions">{util.getSize('insta-post').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'fb-story')}>
                  <span className="option-label">Facebook Story</span>
                  <span className="option-dimensions">{util.getSize('fb-story').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'insta-story')}>
                  <span className="option-label">Instagram Story</span>
                  <span className="option-dimensions">{util.getSize('insta-story').dimensionsLabel}</span>
                </li>
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-half-page-menus-icon`} /></svg>
                Half Page Menu
              </span>
              <ul>
                <li className="option-item" onClick={(e) => this.selectSize(e, 'half-page-menu')}>
                  <span className="option-label">Half Page</span>
                  <span className="option-dimensions">{util.getSize('half-page-menu').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'half-page-menu-long')}>
                  <span className="option-label">Half Page Long</span>
                  <span className="option-dimensions">{util.getSize('half-page-menu-long').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={this.showVariations}>
                  <span className="option-label">Half Page Wide</span>
                  <span className="option-dimensions">{util.getSize('half-page-menu-wide').dimensionsLabel}</span>

                  <ul className="variations">
                    <li onClick={(e) => this.selectSize(e, 'half-page-menu-wide')}><span className="variation-label">Portrait</span></li>
                    <li onClick={(e) => this.selectSize(e, 'half-page-menu-wide-landscape')}><span className="variation-label">Landscape</span></li>
                  </ul>
                </li>

              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-table-tents-icon`} /></svg>
                Table Tents &amp; Inserts
              </span>
              <ul>
                <li className="option-item" onClick={(e) => this.selectSize(e, 'table-tent')}>
                  <span className="option-label">Table Tent</span>
                  <span className="option-dimensions">{util.getSize('table-tent').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'table-tent-insert')}>
                  <span className="option-label">Tabletop Insert</span>
                  <span className="option-dimensions">{util.getSize('table-tent-insert').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'table-tent-insert-4x6')}>
                  <span className="option-label">Tabletop Insert</span>
                  <span className="option-dimensions">{util.getSize('table-tent-insert-4x6').dimensionsLabel}</span>
                </li>
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-kids-menus-icon`} /></svg>
                Kids Menu
              </span>
              <ul>
                <li className="option-item" onClick={this.showVariations}>
                  <span className="option-label">Letter</span>
                  <span className="option-dimensions">{util.getSize('kids-menu-letter-portrait').dimensionsLabel}</span>

                  <ul className="variations">
                    <li onClick={(e) => this.selectSize(e, 'kids-menu-letter-portrait')}><span className="variation-label">Portrait</span></li>
                    <li onClick={(e) => this.selectSize(e, 'kids-menu-letter-landscape')}><span className="variation-label">Landscape</span></li>
                  </ul>
                </li>

                <li className="option-item" onClick={this.showVariations}>
                  <span className="option-label">Legal</span>
                  <span className="option-dimensions">{util.getSize('kids-menu-legal-portrait').dimensionsLabel}</span>

                  <ul className="variations">
                    <li onClick={(e) => this.selectSize(e, 'kids-menu-legal-portrait')}><span className="variation-label">Portrait</span></li>
                    <li onClick={(e) => this.selectSize(e, 'kids-menu-legal-landscape')}><span className="variation-label">Landscape</span></li>
                  </ul>
                </li>

                <li className="option-item" onClick={this.showVariations}>
                  <span className="option-label">Tabloid</span>
                  <span className="option-dimensions">{util.getSize('kids-menu-tabloid-portrait').dimensionsLabel}</span>

                  <ul className="variations">
                    <li onClick={(e) => this.selectSize(e, 'kids-menu-tabloid-portrait')}><span className="variation-label">Portrait</span></li>
                    <li onClick={(e) => this.selectSize(e, 'kids-menu-tabloid-landscape')}><span className="variation-label">Landscape</span></li>
                  </ul>
                </li>

                <li className="option-item" onClick={this.showVariations}>
                  <span className="option-label">A4</span>
                  <span className="option-dimensions">{util.getSize('kids-menu-a4-portrait').dimensionsLabel}</span>

                  <ul className="variations">
                    <li onClick={(e) => this.selectSize(e, 'kids-menu-a4-portrait')}><span className="variation-label">Portrait</span></li>
                    <li onClick={(e) => this.selectSize(e, 'kids-menu-a4-landscape')}><span className="variation-label">Landscape</span></li>
                  </ul>
                </li>
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-business-cards-icon`} /></svg>
                Business &amp; Loyalty Cards
              </span>
              <ul>
                <li className="option-item" onClick={(e) => this.selectSize(e, 'biz-card-landscape')}>
                  <span className="option-label">Landscape Business Card</span>
                  <span className="option-dimensions">{util.getSize('biz-card-landscape').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'biz-card-portrait')}>
                  <span className="option-label">Portrait Business Card</span>
                  <span className="option-dimensions">{util.getSize('biz-card-portrait').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'biz-card-square')}>
                  <span className="option-label">Square Business Card</span>
                  <span className="option-dimensions">{util.getSize('biz-card-square').dimensionsLabel}</span>
                </li>

                <li className={props.isAdmin || props.isDesigner ? 'option-item' : 'option-item hidden'} onClick={(e) => this.selectSize(e, 'biz-card-circular')}>
                  <span className="option-label">Circular Business Card</span>
                  <span className="option-dimensions">{util.getSize('biz-card-circular').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'loyalty-card-landscape')}>
                  <span className="option-label">Landscape Loyalty Card</span>
                  <span className="option-dimensions">{util.getSize('loyalty-card-landscape').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'loyalty-card-portrait')}>
                  <span className="option-label">Portrait Loyalty Card</span>
                  <span className="option-dimensions">{util.getSize('loyalty-card-portrait').dimensionsLabel}</span>
                </li>
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-stickers-icon`} /></svg>
                Stickers &amp; Labels
              </span>
              <ul>
                <li className="option-item" onClick={(e) => this.selectSize(e, 'sticker-landscape')}>
                  <span className="option-label">Landscape Sticker</span>
                  <span className="option-dimensions">{util.getSize('sticker-landscape').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'sticker-portrait')}>
                  <span className="option-label">Portrait Sticker</span>
                  <span className="option-dimensions">{util.getSize('sticker-portrait').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'sticker-square')}>
                  <span className="option-label">Square Sticker</span>
                  <span className="option-dimensions">{util.getSize('sticker-square').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'label-landscape')}>
                  <span className="option-label">Landscape Label</span>
                  <span className="option-dimensions">{util.getSize('label-landscape').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'label-portrait')}>
                  <span className="option-label">Portrait Label</span>
                  <span className="option-dimensions">{util.getSize('label-portrait').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'label-square')}>
                  <span className="option-label">Square Label</span>
                  <span className="option-dimensions">{util.getSize('label-square').dimensionsLabel}</span>
                </li>
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-comment-cards-icon`} /></svg>
                Miscellaneous Marketing
              </span>
              <ul>
                <li className="option-item" onClick={(e) => this.selectSize(e, 'poster')}>
                  <span className="option-label">Poster</span>
                  <span className="option-dimensions">{util.getSize('poster').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'sandwich-board')}>
                  <span className="option-label">Sandwich Board</span>
                  <span className="option-dimensions">{util.getSize('sandwich-board').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'gift-certificate-landscape')}>
                  <span className="option-label">Gift Certificate</span>
                  <span className="option-dimensions">{util.getSize('gift-certificate-landscape').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'comment-card-portrait')}>
                  <span className="option-label">Comment Card</span>
                  <span className="option-dimensions">{util.getSize('comment-card-portrait').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'rack-card-portrait')}>
                  <span className="option-label">Rack Card</span>
                  <span className="option-dimensions">{util.getSize('rack-card-portrait').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'menu-mailer-tabloid-trifold')}>
                  <span className="option-label">Menu Mailer</span>
                  <span className="option-dimensions">{util.getSize('menu-mailer-tabloid-trifold').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'logo')}>
                  <span className="option-label">Logo</span>
                  <span className="option-dimensions">{util.getSize('logo').dimensionsLabel}</span>
                </li>
              </ul>
            </li>

            <li>
              <span className="size-label">
                <svg><use xlinkHref={constants.appPrefix + `/svg/icons.svg#size-takeouts-icon`} /></svg>
                Folded Dine-in Menu
              </span>
              <ul>
                <li className="option-item" onClick={(e) => this.selectSize(e, 'folded-menu-letter-trifold')}>
                  <span className="option-label">Letter Trifold</span>
                  <span className="option-dimensions">{util.getSize('folded-menu-letter-trifold').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'folded-menu-letter-bifold')}>
                  <span className="option-label">Letter Bifold</span>
                  <span className="option-dimensions">{util.getSize('folded-menu-letter-bifold').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'folded-menu-legal-trifold')}>
                  <span className="option-label">Legal Trifold</span>
                  <span className="option-dimensions">{util.getSize('folded-menu-legal-trifold').dimensionsLabel}</span>
                </li>

                <li className="option-item" onClick={(e) => this.selectSize(e, 'folded-menu-tabloid-trifold')}>
                  <span className="option-label">Tabloid Trifold</span>
                  <span className="option-dimensions">{util.getSize('folded-menu-tabloid-trifold').dimensionsLabel}</span>
                </li>
              </ul>
            </li>

            <li class="sep"></li>

            <li className="no-size-results" style="display: none;">
              <span>Sorry, no matches for "{state.searchBy}".<br />Need a custom size?</span>
            </li>

            <li>
              <ul className="custom-size">
                <li>
                  <span className="custom-label">
                    Custom Size
                    <img style="width: 15px; height: 15px; margin-left: 5px;" src="/imageservice/images/img/13/pay-modal/Pro2.svg" alt={''} className={this.props.hasPdfPermission ? 'hidden' : 'pro-star-icon'} />
                  </span>

                  <input className="value" placeholder="Width" min="1" type="number" value={state.width} onKeyUp={this.onChangeCustomWidth} />
                  <label>x</label>
                  <input className="value" placeholder="Height" min="1" type="number" value={state.height} onKeyUp={this.onChangeCustomHeight} />

                  <select value={state.unit} onChange={this.onChangeCustomUnit}>
                    <option value="px">px</option>
                    <option value="in">in</option>
                  </select>
                </li>
                <li className={state.error ? 'error' : 'hidden'}>
                  {state.error}
                </li>
              </ul>
            </li>
          </ul>
        </div>

        {props.embedded !== true &&
          <div className="footer">
            <a className={'btn primary2 ' + ((state.selectedSize && state.selectedSize !== 'custom') ||
              state.width && state.height && state.unit && state.selectedSize === 'custom' && !state.error ? '' : 'disabled')} onClick={this.resize}>Resize</a>
            <a className={'btn primary ' + ((state.selectedSize && state.selectedSize !== 'custom') ||
              state.width && state.height && state.unit && state.selectedSize === 'custom' && !state.error ? '' : 'disabled')} onClick={this.copyAndResize}>Copy &amp; Resize</a>
          </div>
        }

        {props.embedded !== true &&
          <MakeCopyModal
            open={state.isMakeCopyModal}
            onModalClose={this.onMakeCopyModalClose}
            newSize={state.selectedSize}
            cWidth={state.width}
            cHeight={state.height}
            cUnit={state.unit} />
        }
      </div>
    )
  }
}

export default DropdownResize;
